
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"100","viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M85.3 48.9V23c0-3.9-3.2-7-7.2-7H24.9c-4 0-7.2 3.1-7.2 7v26.1c-4 1.5-6.7 5.2-6.7 9.4v16.2c0 3.8 3.2 7 7.2 7 3.8 0 6.9-2.9 7.2-6.5h52.4c.3 3.6 3.4 6.5 7.2 6.5 4 0 7.2-3.1 7.2-7V58.5c-.2-4.2-2.9-7.9-6.9-9.6zM82 74.5v-1.8l-1.9-1.8H22.9L21 72.8v1.8c0 1.5-1.2 2.7-2.8 2.7-1.6 0-2.8-1.2-2.8-2.7V58.5c0-3.3 2.8-6 6.2-6h59.9c3.4 0 6.2 2.7 6.2 6v16.1c0 1.5-1.2 2.7-2.8 2.7-1.6 0-2.9-1.2-2.9-2.8zM28.4 44c.2-.7.8-1.2 1.4-1.2h13.8c.7 0 1.3.5 1.4 1.2l1.3 4.3H27.4l1-4.3zm29.3 0c.2-.7.8-1.2 1.4-1.2H73c.7 0 1.3.5 1.4 1.2l1.2 4.3H56.7l1-4.3zM81 48.3h-.9L78.7 43c-.6-2.6-2.9-4.4-5.7-4.4H59.3c-2.6 0-5 1.8-5.7 4.4l-1.4 5.3h-1.5L49.5 43c-.6-2.6-2.9-4.4-5.7-4.4H30c-2.6 0-5 1.8-5.7 4.4l-1.4 5.3H22V23c0-1.5 1.2-2.7 2.8-2.7H78c1.7-.1 3 1.1 3 2.7v25.3z"}})])
          )
        }
      }
    